import React from 'react';

export default function RiskLevelTable() {
    return (
        <table>
            <tr>
                <td width="80px">投诉风险等级</td>
                <td width="80px">程度</td>
                <td width="300px">明细</td>
            </tr>
            <tr>
                <td>A</td>
                <td>非常严重</td>
                <td>影响后续和客户的合作，要求替换SMO</td>
            </tr>
            <tr>
                <td>B</td>
                <td>严重</td>
                <td>合作方比较关注，要求替换CRC</td>
            </tr>
            <tr>
                <td>C</td>
                <td>中等</td>
                <td>不会影响与合作方关系，但重要操作未按照项目组要求</td>
            </tr>
            <tr>
                <td>D</td>
                <td>轻微</td>
                <td>沟通之间的小摩擦等，PM之间可沟通解决，不产生影响</td>
            </tr>
        </table>
    );
}



// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/RiskLevelTable.js